import { Box, Button, Modal } from '@mui/material';
import { Issue } from '../../../utils/model';
import { ClockRecord } from '../../../components/ClockRecord';
import { useMemo } from 'react';
import { ReportRecord } from '../../../redux/productSlice';
import { dateFilter } from '../../../utils/trackingDateUtils';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  overflowY: 'scroll',
  maxHeight: '90vh',
  p: 4,
};

export const EstimateIssueModal: React.FC<{
  issue: Issue;
  onClose: VoidFunction;
  from: Date;
  to: Date;
}> = ({ issue, onClose, from, to }) => {
  const records = useMemo(() => {
    const records: Record<string, ReportRecord> = {};
    for (const record of issue.timeLogs) {
      if (!records[record.user.name]) {
        records[record.user.name] = {
          author: record.user,
          total: 0,
          records: [],
        };
      }
      if (dateFilter(record.spentAt, from, to)) {
        records[record.user.name].total += record.timeSpent;
      }
      records[record.user.name].records.push(record);
    }
    return Object.values(records);
  }, [from, issue.timeLogs, to]);
  return (
    <Modal onClose={onClose} open sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={style}>
        <Button
          variant="contained"
          color="secondary"
          onClick={onClose}
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          X
        </Button>
        {records.map((record) => (
          <ClockRecord
            key={record.author.username}
            record={record}
            isMob={false}
            highlightDates={{ from, to }}
            highlightDefault
          />
        ))}
      </Box>
    </Modal>
  );
};
